import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { doc } from "firebase/firestore";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { db } from "../../lib/firebase";
import { useFirestoreDocOnce } from "../../hooks/useFirestoreDocOnce";
import { SponsorForm } from "./SponsorForm";
import type { Sponsor } from "@event-planner/shared";

export function SponsorEditPage() {
  const { sponsorId } = useParams<{ sponsorId: string }>();
  const docRef = useMemo(
    () => (sponsorId ? doc(db, "sponsors", sponsorId) : null),
    [sponsorId],
  );
  const { data: sponsor, loading } = useFirestoreDocOnce<Sponsor>(docRef);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!sponsor) {
    return (
      <Box sx={{ py: 4 }}>
        <Typography variant="h5" component="h1">
          Sponsor not found
        </Typography>
        <Typography color="text.secondary" sx={{ mt: 1 }}>
          This sponsor may have been deleted.
        </Typography>
      </Box>
    );
  }

  return <SponsorForm mode="edit" initialData={sponsor} />;
}
